// Module: index.js (components/ds)
// Purpose: Barrel export for the DeeTrade Design System primitive components.
//          Import from one place: `import { Button, Card, Badge } from "components/ds"`.
//
//! DS RULE (10509-11): a DS lifecycle effect (open/close, mount, listener install) depends ONLY on
//   the state that defines the lifecycle (e.g. `open`). NEVER list a consumer-supplied callback
//   prop in its deps: consumers need not memoize, and an inline arrow is a new identity each
//   render, which re-runs the lifecycle. Read callbacks via a latest-ref written in
//   useLayoutEffect (reference: Modal.jsx). Every DS primitive with lifecycle behaviour gets a
//   behaviour test under components/ds/__tests__/ that re-renders with fresh callback identities.

export { Button } from "./Button";
export { Card } from "./Card";
export { Badge } from "./Badge";
export { GlassPanel } from "./GlassPanel";
export { DataTable } from "./DataTable";
export { PageHeader } from "./PageHeader";
export { Breadcrumb } from "./Breadcrumb";
export { Tabs } from "./Tabs";
export { Toolbar } from "./Toolbar";
export { Segmented } from "./Segmented";
export { Loader } from "./Loader";
export { Skeleton } from "./Skeleton";
export { Input } from "./Input";
export { Select } from "./Select";
export { Textarea } from "./Textarea";
export { Toggle } from "./Toggle";
export { Slider } from "./Slider";
export { Checkbox } from "./Checkbox";
export { Modal } from "./Modal";
export { ToastProvider, useToast } from "./Toast";
export { Tooltip } from "./Tooltip";
export { EmptyState } from "./EmptyState";
export { Icon } from "./Icon";
export { ICON_NAMES } from "./icons";
export { BrandReveal } from "./BrandReveal";
export { BrandSplash } from "./BrandSplash";
// Mobile primitive layer (Phase 1)
export { Sheet } from "./Sheet";
export { TabBar } from "./TabBar";
export { MobileHeader } from "./MobileHeader";
export { ListRow } from "./ListRow";
export { SwipeRow } from "./SwipeRow";
export { StatTile, NumberHero } from "./StatTile";
export { Sparkline } from "./Sparkline";
// Signature-moments motion layer (Phase 3)
export { RollingNumber } from "./RollingNumber";
export { TickFlash } from "./TickFlash";
export { PullToRefresh } from "./PullToRefresh";
export { haptics, hapticsEnabled, setHapticsEnabled } from "./haptics";
export { cx } from "./cx";
export { SPRING_SNAPPY, SPRING_SMOOTH, SPRING_BOUNCY, TAP } from "./motion";
